var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":`${_vm.privacyPolicyUrl}`,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }